/**
 * Hero Full Banner Video Module
 * Handles responsive video source switching based on viewport width
 */

export default function initHeroFullBanner() {
  const videoDiv = document.getElementById('hero_video');
  
  if (!videoDiv) return;
  
  const video = videoDiv.querySelector('video');
  if (!video) return;
  
  let screenWidth = window.innerWidth;
  
  // Set initial video source based on screen width
  function setVideoSource() {
    if (screenWidth > 768) {
      const desktopSrc = video.dataset.desktop;
      if (desktopSrc && video.src !== desktopSrc) {
        video.src = desktopSrc;
        video.load();
      }
    } else {
      const mobileSrc = video.dataset.mobile;
      if (mobileSrc && video.src !== mobileSrc) {
        video.src = mobileSrc;
        video.load();
      }
    }
  }
  
  // Set initial source
  setVideoSource();
  
  // Handle resize events
  window.addEventListener('resize', function() {
    const newScreenWidth = window.innerWidth;
    
    // Only change source if crossing the breakpoint
    if (newScreenWidth > 768 && screenWidth <= 768) {
      video.src = video.dataset.desktop;
    } else if (newScreenWidth <= 768 && screenWidth > 768) {
      video.src = video.dataset.mobile;
    }
    
    screenWidth = newScreenWidth;
  });
}
